import React from 'react';
import _noop from 'lodash/noop';
import { useStyletron } from 'baseui';

import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';

import { IContentProps } from '../types';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG_BLOCK, validationSchemaBlock } from '../utils/formConfig';
import useContent from '../utils/useContent';
import { BLOCK_UNBLOCK_ADMIN_ACTION_TYPES } from '../utils/constants';

const Content = (props: IContentProps) => {
	const { handleForceUpdate = _noop } = props;
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleFormSubmit, handleFormCancel } = useContent({
		handleForceUpdate,
		adminActionType: BLOCK_UNBLOCK_ADMIN_ACTION_TYPES.BLOCK
	});

	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG_BLOCK}
				validationSchema={validationSchemaBlock}
				buttonLabels={{
					submitLabel: 'Block',
					discardLabel: 'Cancel'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default Content;
